import { useMemo } from 'react';

import { CoordinationClient, type CoordinationClientType } from '@atlassiansox/engagekit-ts';

export const useCoordinationClient = (
	cloudId: string,
	workspaceId?: string,
	orgId?: string,
): CoordinationClientType => {
	return useMemo(
		() =>
			new CoordinationClient({
				cloudId,
				stargateUrl: '/gateway/api',
				workspaceId,
				orgId,
			}),
		[cloudId, workspaceId, orgId],
	);
};
